import { createSearchSource } from '@gmini/common'

export const searchSourceModel = createSearchSource()
